import * as fromDatatype from '../datatype-library/index';

export interface bl_inv_batch_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  guid_branch: fromDatatype.GuidDataFieldInterface;
  guid_location: fromDatatype.GuidDataFieldInterface;
  batch_no: fromDatatype.VarcharDatatypeInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.TextDatatypeInterface;
  description: fromDatatype.TextDatatypeInterface;
  inv_item_guid: fromDatatype.GuidDataFieldInterface;
  inv_item_code: fromDatatype.VarcharDatatypeInterface;
  qty_balance: fromDatatype.NumericDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  issue_date: fromDatatype.TimestampTzDatatypeInterface;
  expiry_date: fromDatatype.TimestampTzDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class bl_inv_batch_hdr_RowClass
  implements bl_inv_batch_hdr_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    guid_branch: fromDatatype.GuidDataFieldInterface;
    guid_location: fromDatatype.GuidDataFieldInterface;
    batch_no: fromDatatype.VarcharDatatypeInterface;
    code: fromDatatype.VarcharDatatypeInterface;
    name: fromDatatype.TextDatatypeInterface;
    description: fromDatatype.TextDatatypeInterface;
    inv_item_guid: fromDatatype.GuidDataFieldInterface;
    inv_item_code: fromDatatype.VarcharDatatypeInterface;
    qty_balance: fromDatatype.NumericDatatypeInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    issue_date: fromDatatype.TimestampTzDatatypeInterface;
    expiry_date: fromDatatype.TimestampTzDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
    updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
    status: fromDatatype.VarcharDatatypeInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
}